<template>
  <section class="title">
    <div class="container">
      <img :src="logoGus" alt="Gus Machado Games" class="profile-pic" />
    </div>
  </section>

  <GamesAirtimePromo />
</template>

<script setup>
import logoGus from '@/assets/games/gusmachadogames.png'
import GamesAirtimePromo from '@/components/GamesAirtimePromo.vue'
</script>

<style scoped>
.profile-pic {
  width: 200px;
  height: auto;
  margin-bottom: 16px;
  display: block;
}

.title {
  min-height: 0;
  background: var(--color-light);
  color: var(--color-bg-dark);
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 40px 24px;
}

@media (aspect-ratio <= 3/4) {
  .container {
    max-width: none;
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
